import { useState } from 'react';

/**
 * The change a screen sent last, kept so the person can send it once more from its `Problem` when Beyond
 * Accounts did not make it (D186: answered unavailable, or never sent). It is only ever sent again at the
 * person's request, never by itself. A screen keeps a change before sending it only when no action of the
 * change's own stays in view (a menu's entry, a dialog that closed), and clears it before one whose own
 * button stays beside the failure, which a Try again would restate.
 */
export class Last {
	#run?: () => unknown;

	/** Keeps the change about to be sent, with what it was sent with */
	keep(run: () => unknown): void {
		this.#run = run;
	}

	/** Forgets the kept change: the one about to be sent has its own button in view */
	clear(): void {
		this.#run = undefined;
	}

	/** Sends the kept change once more: `Problem`'s `again`, nothing when none is kept */
	again = (): unknown => this.#run?.();

	/** Whether a change is kept, so `Problem` offers Try again only then */
	get kept(): boolean {
		return Boolean(this.#run);
	}
}

/** One `Last` for the life of a screen */
export function useLast(): Last {
	return useState(() => new Last())[0];
}
